import { Children } from 'react';
import isComponentType from './isComponentOfType';
export default ((elements, Component) => {
  const arr = Children.toArray(elements);
  for (let i = 0; i < arr.length; i++) {
    const element = arr[i];
    if (isComponentType(element, Component)) {
      return element;
    }
  }
});